import { DEFAULT_METRICS_TABLE_HEIGHT, PAGE_SIZE_OPTIONS } from '@/pages/dashboard/_config/constant'

export const THEAD_HEIGHT = 42
export const TBODY_HEIGHT = DEFAULT_METRICS_TABLE_HEIGHT
export const PAGING_HEIGHT = 46

export const DEFAULT_PAGING = {
  stateTextVisible: true,
  pageSizeVisible: false,
  pageIndexVisible: false,
  jumpVisible: false,
  endJumpVisible: false,
  pageSizeOptions: PAGE_SIZE_OPTIONS,
}
